/* LinksRenderer.js */

"use strict";

class LinksRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("oslinks-links-column");
        this._rootElem.component = this._model;

        const linkStatus = this._model._linkStatus;

        this._OsLinkEditIcon = document.createElement("actionable-icon-gl");
        this._OsLinkEditIcon.dataset.icon = "common.edit";
        if (linkStatus === "DOWNLOADING" || linkStatus === "UPLOADING") {
            this._OsLinkEditIcon.dataset.disabled = "true";
        }
        this._OsLinkEditIcon.setAttribute("title", "Edit Image");

        this._OsLinkUploadIcon = document.createElement("actionable-icon-gl");
        this._OsLinkUploadIcon.dataset.icon = "common.upload";
        if (
            linkStatus === "EXTERNAL" ||
            linkStatus === "DOWNLOADING" ||
            linkStatus === "UPLOADING"
        ) {
            this._OsLinkUploadIcon.dataset.disabled = "true";
        }
        this._OsLinkUploadIcon.setAttribute("title", "Upload Image");

        this._OsLinkDeleteIcon = document.createElement("actionable-icon-gl");
        this._OsLinkDeleteIcon.dataset.icon = "common.trash_bin";
        if (linkStatus === "DOWNLOADING" || linkStatus === "UPLOADING") {
            this._OsLinkDeleteIcon.dataset.disabled = "true";
        }
        this._OsLinkDeleteIcon.setAttribute("title", "Delete Image");

        this._registerListeners();
        this.render();
    }

    /* *******************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS  */
    /* *******************************************/

    _shutdown() {
        return new Promise((resolve) => {
            this._unregisterListeners();
            this._OsLinkEditIcon.remove();
            this._OsLinkEditIcon = undefined;
            this._OsLinkUploadIcon.remove();
            this._OsLinkUploadIcon = undefined;
            this._OsLinkDeleteIcon.remove();
            this._OsLinkDeleteIcon = undefined;
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
    }

    _registerListeners() {
        this._OsLinkEditIcon.addEventListener(
            "click",
            (this._onClickOsLinkEditIcon = this._onClickOsLinkEditIcon.bind(this))
        );
        this._OsLinkUploadIcon.addEventListener(
            "click",
            (this._onClickOsLinkUploadIcon = this._onClickOsLinkUploadIcon.bind(this))
        );
        this._OsLinkDeleteIcon.addEventListener(
            "click",
            (this._onClickOsLinkDeleteIcon = this._onClickOsLinkDeleteIcon.bind(this))
        );
        this._model.on(
            "LinkStatusPropertyUpdated",
            (this._onLinkStatusPropertyUpdated = this._onLinkStatusPropertyUpdated.bind(this))
        );
    }

    _unregisterListeners() {
        this._OsLinkEditIcon.removeEventListener("click", this._onClickOsLinkEditIcon);
        this._OsLinkUploadIcon.removeEventListener("click", this._onClickOsLinkUploadIcon);
        this._OsLinkDeleteIcon.removeEventListener("click", this._onClickOsLinkDeleteIcon);
        this._model.removeAllListeners("LinkStatusPropertyUpdated");
    }

    _onClickOsLinkEditIcon() {
        this._model.editImage();
    }

    _onClickOsLinkUploadIcon() {
        this._model.uploadImage();
    }

    _onClickOsLinkDeleteIcon() {
        this._model.deleteImage();
    }

    /* ******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS   */
    /* START PUBLIC COMPONENT RENDERER METHODS  */
    /* ******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        this._setIcons(this._model._isDisabled);
        return Promise.resolve();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /* ******************************************/
    /* END COMPONENT RENDERER METHODS           */
    /* START HANDLER METHODS                    */
    /* ******************************************/

    _onLinkStatusPropertyUpdated() {
        this._setIcons(this._model._isDisabled);
    }

    /* ******************************************/
    /* END HANDLER METHODS                      */
    /* START PRIVATE API METHODS                */
    /* ******************************************/

    _setIcons(isDisabled) {
        const linkStatus = this._model._linkStatus;
        const isExternal = linkStatus === "EXTERNAL";

        this._rootElem.innerHTML = "";

        // Edit icon - disabled only during DOWNLOADING/UPLOADING
        this._rootElem.appendChild(this._OsLinkEditIcon);
        this._OsLinkEditIcon.setDisabled(isDisabled);

        // Upload icon - disabled for EXTERNAL, DOWNLOADING, UPLOADING
        this._rootElem.appendChild(this._OsLinkUploadIcon);
        this._OsLinkUploadIcon.setDisabled(isDisabled || isExternal);

        // Delete icon - disabled only during DOWNLOADING/UPLOADING
        this._rootElem.appendChild(this._OsLinkDeleteIcon);
        this._OsLinkDeleteIcon.setDisabled(isDisabled);
    }

    /* *****************************************
    /* END PRIVATE API METHODS
    /* ***************************************** */
}

module.exports = LinksRenderer;
